'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.SignInSuccess = SignInSuccess;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _Grid = require('@material-ui/core/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Button = require('@material-ui/core/Button');

var _Button2 = _interopRequireDefault(_Button);

var _IconButton = require('@material-ui/core/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Typography = require('@material-ui/core/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _AppBar = require('@material-ui/core/AppBar');

var _AppBar2 = _interopRequireDefault(_AppBar);

var _Toolbar = require('@material-ui/core/Toolbar');

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _CheckCircle = require('@material-ui/icons/CheckCircle');

var _CheckCircle2 = _interopRequireDefault(_CheckCircle);

var _Close = require('@material-ui/icons/Close');

var _Close2 = _interopRequireDefault(_Close);

var _colors = require('@material-ui/core/colors');

var _styles = require('@material-ui/core/styles');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gridAttrs = {
  container: true,
  direction: 'column',
  align: 'center',
  justify: 'center',
  wrap: 'nowrap'
};

var close = function close(history) {
  if (window.opener) {
    window.close();
  } else {
    history.replace('/');
  }
};

var _ref = React.createElement(
  _Typography2.default,
  { variant: 'h4', align: 'center' },
  'You\u2019re Signed In'
);

var _ref2 = React.createElement(_Close2.default, null);

function SignInSuccess(props) {
  var classes = props.classes,
      history = props.history;

  return React.createElement(
    'div',
    { className: classes.fadeIn },
    React.createElement(
      _Grid2.default,
      (0, _extends3.default)({}, gridAttrs, { className: classes.grid }),
      React.createElement(_CheckCircle2.default, { className: classes.check }),
      _ref,
      React.createElement(
        _Button2.default,
        { className: classes.gridClose, onClick: function onClick() {
            return close(history);
          } },
        'Close'
      )
    ),
    React.createElement(
      _AppBar2.default,
      { position: 'static' },
      React.createElement(
        _Toolbar2.default,
        { disableGutters: true },
        React.createElement(
          _IconButton2.default,
          {
            'aria-label': 'Close',
            classes: {
              root: classes.buttonRoot
            },
            className: classes.toolbarClose,
            onClick: function onClick() {
              return close(history);
            },
            title: 'Close Window'
          },
          _ref2
        )
      )
    )
  );
}

SignInSuccess.defaultProps = {
  classes: {}
};

var styles = function styles(theme) {
  return {
    fadeIn: {
      animation: 'fadeIn .5s 1s forwards',
      opacity: 0
    },
    '@keyframes fadeIn': {
      '0%': {
        opacity: 0
      },
      '100%': {
        opacity: 1
      }
    },
    grid: {
      margin: 0,
      position: 'fixed',
      top: '64px',
      height: 'calc(100% - 64px)',
      width: '100%'
    },
    check: {
      color: _colors.grey['700'],
      height: '125px',
      width: '125px',
      marginBottom: '40px'
    },
    gridClose: {
      marginBottom: '10px',
      marginTop: '50px'
    },
    toolbarClose: {
      marginLeft: 'auto',
      marginRight: '4px'
    },
    buttonRoot: {
      color: theme.palette.primary.contrastText
    }
  };
};

exports.default = (0, _styles.withStyles)(styles)(SignInSuccess);